/**
 * §05 VOICES SP 1枚見せカルーセル
 *
 * SP (<=768px): 1 枚見せ無限ループ (.artecs-voices__carousel)
 *   先頭/末尾にクローンを挿入し、スクロール検知 → クローン上なら実カードへジャンプ。
 *   ドット (.artecs-voices__dot) と双方向連動。
 * PC: CSS で .artecs-voices__carousel は display:none のため実質無効。
 *
 * record-carousel.js の SP ロジックを踏襲。
 */
( function () {
	'use strict';

	function nearestItem( track, items ) {
		var trackRect = track.getBoundingClientRect();
		var centerX = trackRect.left + trackRect.width / 2;
		var bestIdx = 0;
		var bestDist = Infinity;
		for ( var i = 0; i < items.length; i++ ) {
			var rect = items[ i ].getBoundingClientRect();
			var itemCenter = rect.left + rect.width / 2;
			var dist = Math.abs( itemCenter - centerX );
			if ( dist < bestDist ) {
				bestDist = dist;
				bestIdx = i;
			}
		}
		return bestIdx;
	}

	function setupCarousel( root ) {
		var track = root.querySelector( '.artecs-voices__carousel-track' );
		if ( ! track ) return;

		var realItems = Array.prototype.slice.call(
			track.querySelectorAll( '.artecs-voices__slide' )
		);
		if ( realItems.length <= 1 ) {
			return; // 1 枚以下ならループ不要
		}

		// 先頭末尾にクローンを挿入 (無限ループ用)
		var firstClone = realItems[ 0 ].cloneNode( true );
		var lastClone = realItems[ realItems.length - 1 ].cloneNode( true );
		firstClone.classList.add( 'is-clone' );
		lastClone.classList.add( 'is-clone' );
		firstClone.setAttribute( 'aria-hidden', 'true' );
		lastClone.setAttribute( 'aria-hidden', 'true' );
		track.insertBefore( lastClone, realItems[ 0 ] );
		track.appendChild( firstClone );

		// allItems: [0]=末尾クローン, [1..N]=実カード, [N+1]=先頭クローン
		var allItems = Array.prototype.slice.call(
			track.querySelectorAll( '.artecs-voices__slide' )
		);

		// track 内だけを水平スクロールして el を中央寄せ(ページ縦スクロールには影響しない)。
		function centerItem( el, smooth ) {
			var trackRect = track.getBoundingClientRect();
			var elRect = el.getBoundingClientRect();
			var delta = ( elRect.left - trackRect.left ) - ( track.clientWidth - elRect.width ) / 2;
			track.scrollTo( {
				left: track.scrollLeft + delta,
				behavior: smooth ? 'smooth' : 'auto',
			} );
		}

		// 初期位置を「最初の実カード (= index 1)」にセット
		setTimeout( function () {
			centerItem( allItems[ 1 ], false );
		}, 0 );

		// スクロール停止後にクローン上だったら実カードへジャンプ (無限ループ)
		var scrollTimer = null;
		track.addEventListener( 'scroll', function () {
			if ( scrollTimer ) clearTimeout( scrollTimer );
			scrollTimer = setTimeout( function () {
				var idx = nearestItem( track, allItems );
				if ( idx === 0 ) {
					// 末尾クローン上 → 実 最後尾 (index N) へジャンプ
					centerItem( allItems[ allItems.length - 2 ], false );
				} else if ( idx === allItems.length - 1 ) {
					// 先頭クローン上 → 実 先頭 (index 1) へジャンプ
					centerItem( allItems[ 1 ], false );
				}
			}, 120 );
		} );

		// 前/次 矢印 (無限・自動再生なし) — 事業内容 SP カルーセルと同じ挙動
		function go( delta ) {
			var idx = nearestItem( track, allItems );
			var target = Math.max( 0, Math.min( allItems.length - 1, idx + delta ) );
			centerItem( allItems[ target ], true );
		}
		var prev = root.querySelector( '[data-voices-prev]' );
		var next = root.querySelector( '[data-voices-next]' );
		if ( prev ) prev.addEventListener( 'click', function () { go( -1 ); } );
		if ( next ) next.addEventListener( 'click', function () { go( 1 ); } );
	}

	function init() {
		var carousels = document.querySelectorAll( '.artecs-voices__carousel' );
		for ( var i = 0; i < carousels.length; i++ ) {
			setupCarousel( carousels[ i ] );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
